import styles from './mediablock.css'

type MediaItemProps = {
  title: string
  file_format: string
  download_url: string
  preview_image: string
}

const MediaItem = ({ title, file_format, download_url, preview_image }: MediaItemProps): JSX.Element => (
  <a href={download_url} target="_blank" rel="noopener noreferrer">
    <div
      className={styles.image}
      style={{
        backgroundImage: `url("/is/${preview_image}/fill-330x200/")`,
      }}
    />
    <p className={styles.itemTitle}>
      {title}
      {file_format && <span className={styles.format}> ({file_format})</span>}
    </p>
  </a>
)

type MediaBlockProps = {
  value: {
    heading: string
    media: Array<MediaItemProps>
  }
}

const MediaBlock = ({ value: { heading, media } }: MediaBlockProps): JSX.Element => (
  <div className={styles.wrapper}>
    <h2 className={styles.title}>{heading}</h2>
    <ul>
      {media.map((mediaItem, i) => (
        <li key={String(i)}>
          <MediaItem {...mediaItem} />
        </li>
      ))}
    </ul>
  </div>
)

export default MediaBlock
